<template>
    <ul :class="[prefixCls + '-list']" class="clear">
        <li
            v-for="file in files"
            :class="fileCls(file)"
            ref="fileli">
            <span :class="[prefixCls + '-list-name']" class="pric" :title="file.name" @click="handlePreview(file)" v-if="file.percentage == 100">
               <i class="iconfont" :class="format(file)"></i> {{ file.name }}
            </span>
            <img :src="file.url |suffix" v-if="file.url"/>
            <img :src="file.response.model" v-if="!file.url&&file.response"/>
    		<div :class="[prefixCls + '-list-shade']" v-if="!file.showProgress">
    			<span class="upload-icon">
        			<i class="icon-Oval" @click="handlePreview(file)"></i>
	        		<i class="icon-bottom"  @click="handleClick(file)"></i>
	        		<i class="icon-trash" @click="handleRemove(file)"></i>
        		</span>
    		</div>
            <transition name="fade">
              <ProgressBar  
              	v-if="file.showProgress"
              	type="success"
              	:percent="parsePercentage(file.percentage)" 
              	:status="file.status === 'finished' && file.showProgress ? 'success' : 'normal'" 
              	size="small" 
              	:showinfo="true" 
              	:format="percentFormat"
              	:info-inside="false">
              </ProgressBar>
            </transition>
        </li>
    </ul>
</template>
<script>
    import progressbae from '../progressbar/ProgressBar.vue';
    const prefixCls = 'fcupload';

    export default {
        name: 'UploadList',
        components: {  progressbae },
        props: {
            files: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        data () {
            return {
                prefixCls: prefixCls
            };
        },
        filters:{
        	suffix(val) {
        		var imgExt = new Array('gif','jpg','jpeg','png','bmp','webp');
        		String.prototype.extension = function(){
				    var ext = null;
				    var name = this.toLowerCase();
				    var i = name.lastIndexOf(".");
				    if(i > -1){
				    var ext = name.substring(i);
				    }
				    return ext;
				}
				
				//判断Array中是否包含某个值
				Array.prototype.contain = function(obj){
				    for(var i=0; i<this.length; i++){
				        if(this[i] === obj)
				            return true;
				    }
				    return false;
				};
				
				function typeMatch(type, filename){
				    var ext = filename.extension();
				    if(type.contain(ext)){        
				        return true;
				    }
				    return false;
				}
				if(typeMatch(imgExt,val)){
					console.log(5555)
//				   alert("是图片文件");    
				}else{
					return val
					console.log(9999)
				}
        	}
        },
        methods: {
            fileCls (file) {
                return [
                    `${prefixCls}-list-file`,
                    {
                        [`${prefixCls}-list-file-finish`]: file.status === 'finished'
                    }
                ];
            },
            handleClick (file) {
                this.$emit('on-file-click', file);
            },
            handlePreview (file) {
                this.$emit('on-file-preview', file);
            },
            handleRemove (file) {
                this.$emit('on-file-remove', file);
            },
            format (file) {
                const format = file.name.split('.').pop().toLocaleLowerCase() || '';
                let type = 'document';
					
                if (['gif','jpg','jpeg','png','bmp','webp'].indexOf(format) > -1) {
                    type = 'image';
                }
                if (['mp4','m3u8','rmvb','avi','swf','3gp','mkv','flv'].indexOf(format) > -1) {
                    type = 'ios-film';
                }
                if (['mp3','wav','wma','ogg','aac','flac'].indexOf(format) > -1) {
                    type = 'ios-musical-notes';
                }
                if (['doc','txt','docx','pages','epub','pdf'].indexOf(format) > -1) {
                    type = 'document-text';
                }
                if (['numbers','csv','xls','xlsx'].indexOf(format) > -1) {
                    type = 'stats-bars';
                }
                if (['keynote','ppt','pptx'].indexOf(format) > -1) {
                    type = 'ios-videocam';
                }

                return type;
            },
            parsePercentage (val) {
                return parseInt(val, 10);
            },
            percentFormat(val) {
		        return `导入中 ${val}%`;
		    },
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/upload/upload-list.vue